import {
    POST_LIST_REQUEST,
    POST_LIST_SUCCESS,
    POST_LIST_FAIL,

    POST_DETAILS_REQUEST,
    POST_DETAILS_SUCCESS,
    POST_DETAILS_FAIL,

    POST_DELETE_REQUEST,
    POST_DELETE_SUCCESS,
    POST_DELETE_FAIL,
 
    WORK_LIST_REQUEST,
    WORK_LIST_SUCCESS,
    WORK_LIST_FAIL,
 
    LINK_LIST_REQUEST,
    LINK_LIST_SUCCESS,
    LINK_LIST_FAIL,
 
    OUTER_POST_LIST_REQUEST,
    OUTER_POST_LIST_SUCCESS,
    OUTER_POST_LIST_FAIL,

    OUTER_POST_DETAILS_REQUEST,
    OUTER_POST_DETAILS_SUCCESS,
    OUTER_POST_DETAILS_FAIL,

    OUTER_POST_DELETE_REQUEST,
    OUTER_POST_DELETE_SUCCESS,
    OUTER_POST_DELETE_FAIL,
 
    OUTER_POST_CREATE_REQUEST,
    OUTER_POST_CREATE_SUCCESS,
    OUTER_POST_CREATE_FAIL,
    OUTER_POST_CREATE_RESET,
 
    COMMENT_LIST_REQUEST,
    COMMENT_LIST_SUCCESS,
    COMMENT_LIST_FAIL,
 
    COMMENT_CREATE_REQUEST,
    COMMENT_CREATE_SUCCESS,
    COMMENT_CREATE_FAIL,
    COMMENT_CREATE_RESET,

    COMMENT_LIST_ALL_REQUEST,
    COMMENT_LIST_ALL_SUCCESS,
    COMMENT_LIST_ALL_FAIL,

    COMMENT_DELETE_REQUEST,
    COMMENT_DELETE_SUCCESS,
    COMMENT_DELETE_FAIL,
} from '../constants/mediaConstants'
 
 
export const postListReducer = (state = {posts: []}, action) => {
 
 
    switch (action.type) {
        case POST_LIST_REQUEST:
            return { loading:true, posts: []}
 
        case POST_LIST_SUCCESS:
            return { loading: false,
                      posts: action.payload.posts,
                      page: action.payload.page,
                      pages: action.payload.pages }
        
        case POST_LIST_FAIL:
            return {loading: false, error: action.payload, posts: []}
        
        default:
            return state
    }
}
 
export const workListReducer = (state = {works: []}, action) => {
 
 
    switch (action.type) {
        case WORK_LIST_REQUEST:
            return { loading:true, works: []}
 
        case WORK_LIST_SUCCESS:
            return { loading: false,
                      works:action.payload}
        
        case WORK_LIST_FAIL:
            return {loading: false, error: action.payload}
        
        default:
            return state
    }
}
 
export const linkListReducer = (state = {links: []}, action) => {
 
 
    switch (action.type) {
        case LINK_LIST_REQUEST:
            return { loading:true, links: []}
 
        case LINK_LIST_SUCCESS:
            return { loading: false,
                      links:action.payload}
        
        case LINK_LIST_FAIL:
            return {loading: false, error: action.payload}
        
        default:
            return state
    }
}
 
 
export const outerPostListReducer = (state = {outerposts: []}, action) => {
 
 
    switch (action.type) {
        case OUTER_POST_LIST_REQUEST:
            return { loading:true, outerposts: []}
 
        case OUTER_POST_LIST_SUCCESS:
            return { loading: false,
                      outerposts: action.payload.outerposts,
                      page: action.payload.page,
                      pages: action.payload.pages }
        
        case OUTER_POST_LIST_FAIL:
            return {loading: false, error: action.payload, outerposts: []}
        
        default:
            return state
    }
}
 
export const outerPostCreateReducer = (state = {} , action) => { 
    switch (action.type) {
        case OUTER_POST_CREATE_REQUEST:  
            return { loading: true }
 
        case OUTER_POST_CREATE_SUCCESS:
            return { loading: false, success: true, outerpost:action.payload } 
            
        case OUTER_POST_CREATE_FAIL:
            return { loading: false, error: action.payload }
 
        case OUTER_POST_CREATE_RESET:  
            return {}
         
        default:
            return state
    }
 
}
 
 
export const commentListReducer = (state = { comments: [] }, action) => {
    switch (action.type) {
        case COMMENT_LIST_REQUEST:
            return { loading: true, comments: [] }
 
        case COMMENT_LIST_SUCCESS:
            return { loading: false, comments: action.payload }
 
        case COMMENT_LIST_FAIL:
            return { loading: false, error: action.payload }
 
        default:
            return state
    }
}
 
 
export const commentCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case COMMENT_CREATE_REQUEST:
            return { loading: true }
 
        case COMMENT_CREATE_SUCCESS:
            return { loading: false, success: true, comment: action.payload }
 
        case COMMENT_CREATE_FAIL:
            return { loading: false, error: action.payload }
 
        case COMMENT_CREATE_RESET:
            return {}
 
        default:
            return state
    }
}

export const commentListAllReducer = (state = { comments: [] }, action) => {
    switch (action.type) {
        case COMMENT_LIST_ALL_REQUEST:
            return { loading: true, comments: [] }

        case COMMENT_LIST_ALL_SUCCESS:
            return { loading: false, comments: action.payload }

        case COMMENT_LIST_ALL_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}


export const commentDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case COMMENT_DELETE_REQUEST:
            return { loading: true }

        case COMMENT_DELETE_SUCCESS:
            return { loading: false, success: true }

        case COMMENT_DELETE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}


export const postDetailsReducer = (state = { post: {} }, action) => {
    switch (action.type) {
        case POST_DETAILS_REQUEST:
            return { loading: true, post: {} }

        case POST_DETAILS_SUCCESS:
            return { loading: false, post: action.payload }

        case POST_DETAILS_FAIL:
            return { loading: false, error: action.payload, post: {} }

        default:
            return state
    }
}


export const outerPostDetailsReducer = (state = { outerpost: {} }, action) => {
    switch (action.type) {
        case OUTER_POST_DETAILS_REQUEST:
            return { loading: true, outerpost: {} }

        case OUTER_POST_DETAILS_SUCCESS:
            return { loading: false, outerpost: action.payload }

        case OUTER_POST_DETAILS_FAIL:
            return { loading: false, error: action.payload, outerpost: {} }

        default:
            return state
    }
}


export const postDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case POST_DELETE_REQUEST:
            return { loading: true }

        case POST_DELETE_SUCCESS:
            return { loading: false, success: true }

        case POST_DELETE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}


export const outerPostDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case OUTER_POST_DELETE_REQUEST:
            return { loading: true }

        case OUTER_POST_DELETE_SUCCESS:
            return { loading: false, success: true }

        case OUTER_POST_DELETE_FAIL:
            return { loading: false, error: action.payload }

        default:
            return state
    }
}